import React from 'react';
import { CTABlock, Icon } from 'library';

import { COMPARISON_TABLE_DATA, MOBILE_COLUMNS } from '../../../constants/comparisonTableData';
import BaseTable from '../BaseTable/BaseTable';
import TableSectionWrapper from '../TableSectionWrapper/TableSectionWrapper';

const QualificationTable = () => {
  return (
    <TableSectionWrapper theme="medium">
      <CTABlock
        title="Qualification criteria"
        text="Looking for more info on different ways to tap into your home equity? Download our helpful
          guide to reference as you compare your options."
        buttonLabel={
          <span>
            Download the Guide <Icon name="arrow-right" />
          </span>
        }
        buttonLink="/homeowner-resources/options-for-tapping-into-your-homes-equity/"
        buttonTheme="text"
        className="TableSectionHeading"
      />
      <BaseTable
        data={COMPARISON_TABLE_DATA.qualifications}
        mobileColumns={MOBILE_COLUMNS.qualifications}
        logoColumnBackground="white"
      />
    </TableSectionWrapper>
  );
};

export default QualificationTable;
